"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 19 14'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-52.000000, -118.000000)',
    fillRule: 'nonzero',
    fill: 'currentColor'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(61.428571, 125.000000) rotate(-90.000000) translate(-61.428571, -125.000000) translate(55.000000, 116.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M9.55470536,2.93954464 C9.31339286,2.68979464 8.91176786,2.68979464 8.66201786,2.93954464 C8.42070536,3.18085714 8.42070536,3.58248214 8.66201786,3.82323214 L13.1884554,8.34966964 L-1.74816964,8.34966964 C-2.09635714,8.35023214 -2.37310714,8.62698214 -2.37310714,8.97516964 C-2.37310714,9.32335714 -2.09635714,9.60910714 -1.74816964,9.60910714 L13.1884554,9.60910714 L8.66201786,14.1271071 C8.42070536,14.3768571 8.42070536,14.7790446 8.66201786,15.0197946 C8.91176786,15.2695446 9.31395536,15.2695446 9.55470536,15.0197946 L15.1527054,9.42179464 C15.4024554,9.18048214 15.4024554,8.77885714 15.1527054,8.53810714 L9.55470536,2.93954464 Z',
    transform: 'translate(6.483455, 8.979670) rotate(-90.000000) translate(-6.483455, -8.979670) '
  })))));
};
/* eslint-enable */
var _default = ArrowBack;
exports["default"] = _default;